"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }
var _uploadFailure = require('shared/services/uploadFailure');








var _uploadDirect = require('./uploadDirect');
















// Direct-upload refusals the legacy path doesn't have: /upload_file takes
// the file instead.
// "upload session is closed": a retry of a message whose direct upload was
// cancelled or expired; /upload_file sends it under the same MessageKey.
// "upload already completed": a retry that no longer knows the earlier
// upload's key (see previousUploadKey), after a finalize the server finished
// (and posted). The re-upload's SendMessageToConversation is deduped by
// MessageKey and succeeds, which clears the failed bubble; the second copy of
// the file goes unused.
const LEGACY_FALLBACK_ERRORS = new Set([
  'too many uploads in progress',
  'invalid upload content type',
  'upload session is closed',
  'upload already completed',
])

const isLegacyFallback = (err) =>
  !!err && typeof err === 'object' && LEGACY_FALLBACK_ERRORS.has(_nullishCoalesce((err ).Error, () => ( '')))

// Uploads straight to GCS when the server takes direct uploads, and through
// /upload_file otherwise (kill switch off, an older server, no transport, or
// a refusal only the direct path has). A file over the size limit is refused
// on either path before any byte goes out, with an UploadTooLargeError.
 const uploadFileWithFallback = async ({
  send, transport, request, legacyUpload, onProgress, onStarted, onLanded, previousUploadKey, signal, commands,
}) => {
  if (_uploadFailure.isUploadTooLargeSize.call(void 0, request.Size)) throw new (0, _uploadFailure.UploadTooLargeError)()
  if (!transport || !_uploadDirect.directUploadMaybeAvailable.call(void 0, ) || request.Size <= 0) return legacyUpload()
  try {
    return await _uploadDirect.uploadDirect.call(void 0, { send, transport, request, onProgress, onStarted, onLanded, previousUploadKey, signal, commands })
  } catch (err) {
    if (err instanceof _uploadDirect.DirectUploadUnavailableError || isLegacyFallback(err)) return legacyUpload()
    // The server's limit, should ours ever be out of step with it.
    if (_uploadFailure.isUploadTooLarge.call(void 0, err)) throw new (0, _uploadFailure.UploadTooLargeError)()
    throw err
  }
}; exports.uploadFileWithFallback = uploadFileWithFallback












// A standalone file (CSV import, form attachment): no conversation, so the
// server only stores it and returns the FileKey, as /upload_file does.
 const uploadFileDirect = (
  client,
  file,
  { transport, onProgress, signal } = {},
) => exports.uploadFileWithFallback.call(void 0, {
  send: client.send,
  transport,
  request: { Purpose: 'file', FileName: file.name, Mime: file.type || 'application/octet-stream', Size: file.size },
  legacyUpload: () => client.uploadFile(file , signal),
  onProgress,
  signal,
}); exports.uploadFileDirect = uploadFileDirect

// A patient's attachment: uploaded to GCS within the patient's authenticated
// conversation, then sent with SendPatientConversationMessage as before.
 const uploadPatientFileDirect = (
  client,
  file,
  conversationKey,
  { transport, onProgress, signal } = {},
) => exports.uploadFileWithFallback.call(void 0, {
  send: client.send,
  transport,
  request: {
    Purpose: 'file', ConversationKey: conversationKey, FileName: file.name,
    Mime: file.type || 'application/octet-stream', Size: file.size,
  },
  legacyUpload: () => client.uploadFile(file , signal),
  onProgress,
  signal,
  commands: _uploadDirect.PATIENT_UPLOAD_COMMANDS,
}); exports.uploadPatientFileDirect = uploadPatientFileDirect
